import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import '../styles/HptScreens.css';
import SignaturePad from './SignaturePad';
import imagenFondo from '../assets/logo_elecnor.jpg';
import html2pdf from 'html2pdf.js';

const API_URL = process.env.REACT_APP_API_URL;

const PermisoEscalera = ({ datosPrevios, onSave, onCancel, readOnly = false, usuarioActual, isPdfMode = false }) => {
    
    const { id } = useParams();
    const navigate = useNavigate();
    const isStandalone = typeof onSave !== 'function' && !isPdfMode;
    const pdfRef = useRef();
    const [isPrintingLocal, setIsPrintingLocal] = useState(false);

    const [formData, setFormData] = useState(datosPrevios || {
        fechaSolicitud: new Date().toISOString().split('T')[0],
        delegacion: '', ubicacion: '', responsable: '', ordenTrabajo: '',
        altura: '', trabajoRealizar: '', numeroSerie: '',
        checkId: false, checkZona: false, checkPeldaños: false, checkZapatas: false,
        clasificacion: [], justificacion: [],
        firmaSolRetirada: null, firmaAutRetirada: null, firmaUsuEscalera: null,
        firmaSolDevolucion: null, firmaRecDevolucion: null, medioAutorizacion: ''
    });

    const [firmaActiva, setFirmaActiva] = useState(null);

    useEffect(() => {
        if (isStandalone && id) {
            const cargarDatos = async () => {
                try {
                    const token = localStorage.getItem('userToken');
                    const res = await axios.get(`${API_URL}/api/hpt/escalera/${id}`, {
                        headers: { Authorization: `Bearer ${token}` }
                    });
                    
                    const dataBD = res.data;
                    const toBool = (v) => v === 1 || v === true || v === '1' || v === 'true';
                    
                    setFormData({
                        fechaSolicitud: dataBD.fecha_solicitud || "",
                        delegacion: dataBD.delegacion || "",
                        ubicacion: dataBD.ubicacion || "",
                        responsable: dataBD.responsable || "",
                        ordenTrabajo: dataBD.orden_trabajo || "",
                        trabajoRealizar: dataBD.trabajo_realizar || "",
                        numeroSerie: dataBD.numero_serie || "",
                        medioAutorizacion: dataBD.medio_autorizacion || "",
                        altura: dataBD.altura !== null ? Number(dataBD.altura) : '',
                        checkId: toBool(dataBD.check_id),
                        checkZona: toBool(dataBD.check_zona),
                        checkPeldaños: toBool(dataBD.check_peldaños),
                        checkZapatas: toBool(dataBD.check_zapatas),
                        clasificacion: dataBD.clasificacion ? dataBD.clasificacion.split(', ') : [],
                        justificacion: dataBD.justificacion ? dataBD.justificacion.split(', ') : [],
                        firmaSolRetirada: dataBD.firma_sol_retirada ? JSON.parse(dataBD.firma_sol_retirada) : null,
                        firmaAutRetirada: dataBD.firma_aut_retirada ? JSON.parse(dataBD.firma_aut_retirada) : null,
                        firmaUsuEscalera: dataBD.firma_usu_escalera ? JSON.parse(dataBD.firma_usu_escalera) : null,
                        firmaSolDevolucion: dataBD.firma_sol_devolucion ? JSON.parse(dataBD.firma_sol_devolucion) : null,
                        firmaRecDevolucion: dataBD.firma_rec_devolucion ? JSON.parse(dataBD.firma_rec_devolucion) : null
                    });
                } catch (error) {
                    Swal.fire('Error', 'No se pudo cargar el documento', 'error');
                }
            };
            cargarDatos();
        }
    }, [id, isStandalone]);

    const handleGuardarDirecto = async () => {
        try {
            const token = localStorage.getItem('userToken');
            const config = { headers: { Authorization: `Bearer ${token}` } };
            const payload = { ...formData, id_hpt: null };

            if (id) {
                await axios.put(`${API_URL}/api/hpt/escalera/${id}`, payload, config);
                Swal.fire({
                    title: "¡Actualizado!", text: `Registro actualizado correctamente`, icon: "success",
                    confirmButtonColor: '#003366', timer: 2500
                });
            }else{
                const res = await axios.post(`${API_URL}/api/hpt/escalera`, payload, config);

                Swal.fire({
                    title: "¡Guardado!", text: `Registrado con ID: ${res.data.id_registro}`, icon: "success",
                    confirmButtonColor: '#003366', timer: 2500
                });
            }
        } catch (error) {
            Swal.fire('Error', 'No se pudo guardar en el servidor.', 'error');
        }
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        if (name === 'justificacion' || name === 'clasificacion') {
            let nuevoArray = [...formData[name]];
            if (checked) nuevoArray.push(value);
            else nuevoArray = nuevoArray.filter(item => item !== value);
            setFormData({ ...formData, [name]: nuevoArray });
            return;
        }
        setFormData({ ...formData, [name]: type === 'checkbox' ? checked : value });
    };

    const handleGuardarFirma = (base64) => {
        const fechaHora = new Date().toLocaleString('es-ES');
        let nombreCompleto = usuarioActual;
        if (!nombreCompleto) {
            const token = localStorage.getItem('userToken');
            if (token) {
                const dec = JSON.parse(atob(token.split('.')[1]));
                nombreCompleto = `${dec.nombre || ''} ${dec.apellidos || ''}`.trim() || dec.user;
            } else {
                nombreCompleto = 'Usuario Desconocido';
            }
        }

        setFormData({
            ...formData,
            [firmaActiva]: { base64: base64, nombre: nombreCompleto, fechaHora: fechaHora }
        });
        setFirmaActiva(null);
    };

    const renderCajaFirma = (label, fieldKey) => {
        const firma = formData[fieldKey];
        return (
            <div className="pe-sign-line" style={{ display: 'flex', flexDirection: 'column', gap: '8px', paddingBottom: '10px' }}>
                <span style={{ fontWeight: 'bold' }}>{label}:</span>
                {firma ? (
                    <div style={{ backgroundColor: '#f9f9f9', padding: '10px', borderRadius: '4px', border: '1px solid #ddd' }}>
                        <img src={firma.base64} alt="Firma" style={{ height: '40px', display: 'block', marginBottom: '5px' }} />
                        <div style={{ fontSize: '10px', color: '#555' }}>
                            <strong>Firmado por:</strong> {firma.nombre}
                            <strong>Fecha:</strong> {firma.fechaHora}
                        </div>
                    </div>
                ) : (
                    !readOnly && (
                        <button type="button" className="btn-save" style={{ width: 'fit-content', padding: '4px 10px', fontSize: '11px', backgroundColor: '#003366' }} onClick={() => setFirmaActiva(fieldKey)}>
                            ✍️ Firmar
                        </button>
                    )
                )}
            </div>
        );
    };

    const handleDescargarPDF = () => {
        setIsPrintingLocal(true);
        Swal.fire({ title: 'Generando documento...', text: 'Por favor espera', allowOutsideClick: false, didOpen: () => Swal.showLoading() });
        setTimeout(() => {
            const element = pdfRef.current;
            const opt = {
                margin:       [10, 5, 10, 5],
                filename:     `Permiso_${new Date().getTime()}.pdf`,
                image:        { type: 'jpeg', quality: 0.98 },
                html2canvas:  { scale: 2, useCORS: true, windowWidth: 720 },
                jsPDF:        { unit: 'mm', format: 'a4', orientation: 'portrait', compress: true },
                pagebreak:    { mode: ['css', 'legacy'] }
            };
            html2pdf().set(opt).from(element).save().then(() => {
                setIsPrintingLocal(false);
                Swal.close();
            });
        }, 800);
    };

    const contenidoFormulario = (
        <div className={`pe-container ${isPdfMode || isPrintingLocal ? 'pe-pdf-mode' : 'pe-modal-content'}`}>
            <div ref={pdfRef}
                className={`pe-container ${isPdfMode || isPrintingLocal ? 'pe-pdf-mode' : 'pe-modal-content'}`}
                style={isPrintingLocal ? { width: '720px', maxWidth: '720px', margin: '0 auto', backgroundColor: '#fff', transform: 'none' } : {}}

            >
                <header className="pe-header">
                    <div className="pe-title-box"><h2 className="pe-main-title">PERMISO ESPECIAL: USO DE ESCALERAS MANUALES</h2></div>
                    <div className="pe-logo"><img src={imagenFondo} alt="Logo" style={{ maxHeight: '40px' }} /> </div>
                    <div className="pe-code">FIT.ELN.GEN-08.040.03</div>
                </header>

                <section className="pe-section">
                    <h3 className="pe-section-title">0. DATOS DE LA SOLICITUD</h3>
                    <div className="pe-dat_sol-2">
                        <div className="pe-input-group"><label>FECHA SOLICITUD:</label><input type="date" name="fechaSolicitud" value={formData.fechaSolicitud} onChange={handleChange} className="pe-input" /></div>
                        <div className="pe-input-group"><label>Nº PERMISO / ORDEN DE TRABAJO:</label><input type="text" name="ordenTrabajo" value={formData.ordenTrabajo} onChange={handleChange} className="pe-input" /></div>
                        <div className="pe-input-group"><label>DELEGACIÓN - CP-CT / SUBCONTRATISTA:</label><input type="text" name="delegacion" value={formData.delegacion} onChange={handleChange} className="pe-input" /></div>
                        <div className="pe-input-group"><label>Nº OBRA / UBICACIÓN:</label><input type="text" name="ubicacion" value={formData.ubicacion} onChange={handleChange} className="pe-input" /></div>
                        <div className="pe-input-group pe-col-span-2"><label>RESPONSABLE TRABAJOS (ELECNOR / SUBCON.):</label><input type="text" name="responsable" value={formData.responsable} onChange={handleChange} className="pe-input" /></div>
                    </div>
                </section>

                <div className={`pe-alert ${formData.altura > 6 ? 'pe-alert-danger' : ''}`}>
                    SI LA ALTURA SUPERA LOS 6M NO USAR ESCALERA, CONTACTAR LÍNEA DE MANDO.
                </div>

                <section className="pe-section">
                    <h3 className="pe-section-title">1. PUNTO DE TRABAJO</h3>
                    <div className="pe-grid-2">
                        <div className="pe-input-group"><label>ALTURA (m):</label><input type="number" step="0.1" name="altura" value={formData.altura || ''} onChange={handleChange} className="pe-input" placeholder="Ej: 2.5" /></div>
                        <div className="pe-input-group"><label>TRABAJO A REALIZAR:</label><input type="text" name="trabajoRealizar" value={formData.trabajoRealizar} onChange={handleChange} className="pe-input" /></div>
                    </div>
                </section>

                <section className="pe-section">
                    <h3 className="pe-section-title">2. CHECKLIST PRE-USO</h3>
                    <div className="pe-input-group pe-serie-group"><label>NÚMERO DE SERIE DE LA ESCALERA:</label><input type="text" name="numeroSerie" value={formData.numeroSerie} onChange={handleChange} className="pe-input" /></div>
                    <div className="pe-checklist-grid">
                        <label className="pe-check-label"><input type="checkbox" name="checkId" checked={formData.checkId} onChange={handleChange} /> ¿Escalera con ID y revisión anual vigente?</label>
                        <label className="pe-check-label"><input type="checkbox" name="checkZona" checked={formData.checkZona} onChange={handleChange} /> ¿Zona balizada y señalizada?</label>
                        <label className="pe-check-label"><input type="checkbox" name="checkPeldaños" checked={formData.checkPeldaños} onChange={handleChange} /> ¿Largueros/peldaños en perfecto estado?</label>
                        <label className="pe-check-label"><input type="checkbox" name="checkZapatas" checked={formData.checkZapatas} onChange={handleChange} /> ¿Zapatas y dispositivos de apertura en perfecto estado?</label>
                    </div>
                </section>

                <section className="pe-section">
                    <h3 className="pe-section-title">3. CLASIFICACIÓN Y JUSTIFICACIÓN</h3>
                    <div className="pe-grid-2">
                        <div className="pe-box-bordered">
                            <div className="pe-radio-list">
                                <label><input type="checkbox" name="clasificacion" value="< 3,5 m" checked={formData.clasificacion.includes('< 3,5 m')} onChange={handleChange} /> Trabajos &lt; 3,5 m</label>
                                <label><input type="checkbox" name="clasificacion" value="3,5 a 6 m" checked={formData.clasificacion.includes('3,5 a 6 m')} onChange={handleChange} /> Trabajos entre 3,5 y 6 m</label>
                                <label><input type="checkbox" name="clasificacion" value="Encofrado" checked={formData.clasificacion.includes('Encofrado')} onChange={handleChange} /> Encofrado / Ferrallado</label>
                                <label><input type="checkbox" name="clasificacion" value="Apoyos" checked={formData.clasificacion.includes('Apoyos')} onChange={handleChange} /> Apoyos con antiescalos</label>
                                <label><input type="checkbox" name="clasificacion" value="Interiores" checked={formData.clasificacion.includes('Interiores')} onChange={handleChange} /> Interiores 3.5 - 6 m</label>
                                <label><input type="checkbox" name="clasificacion" value="Cubiertas" checked={formData.clasificacion.includes('Cubiertas')} onChange={handleChange} /> Acceso a cubiertas (H &lt; 7m)</label>
                            </div>
                            <h4 className="pe-box-subtitle">¿POR QUÉ NO PEMP/ANDAMIO?</h4>
                            <div className="pe-radio-list">
                                <label><input type="checkbox" name="justificacion" value="Inaccesible" checked={formData.justificacion.includes("Inaccesible")} onChange={handleChange} /> Ubicación inaccesible</label>
                                <label><input type="checkbox" name="justificacion" value="Superficie" checked={formData.justificacion.includes("Superficie")} onChange={handleChange} /> Superficie no apta</label>
                                <label><input type="checkbox" name="justificacion" value="Espacio" checked={formData.justificacion.includes("Espacio")} onChange={handleChange} /> Espacio insuficiente</label>
                            </div>
                        </div>
                    </div>
                </section>

                <div className="pe-signature-box">
                    <strong>RETIRADA (REVISADA Y BUEN ESTADO):</strong>
                    <div className='agr-sign-ret'>
                        {renderCajaFirma('Solicitante', 'firmaSolRetirada')}
                        {renderCajaFirma('Autoriza ELECNOR', 'firmaAutRetirada')}
                    </div>
                    <div className="pe-input-autho"><label>*Medio de autorización:</label><input type="text" name="medioAutorizacion" value={formData.medioAutorizacion} onChange={handleChange} disabled={readOnly}/></div>
                    {renderCajaFirma('Usuario(s) de escalera', 'firmaUsuEscalera')}
                </div>
                
                <div className="pe-signature-box">
                    <strong>DEVOLUCIÓN (REVISADA Y BUEN ESTADO):</strong>
                    <div className='agr-sign-ret'>
                        {renderCajaFirma('Solicitante', 'firmaSolDevolucion')}
                        {renderCajaFirma('Recibe ELECNOR', 'firmaRecDevolucion')}
                    </div>
                </div>

                <div className="pe-footer-note">
                    <span>AUTORIZACIÓN EXPRESA Y POR ESCRITO A LA LÍNEA DE MANDO DE ELECNOR.</span>
                    <div className='pe-footer-line'></div>
                    Archivar formato original en almacen y adjuntar copia en cierre de OT o PT
                </div>

            </div>

            {/* BOTONERA INTELIGENTE */}
            {!isPdfMode && (
                <div className="pe-modal-actions">
                    <button type="button" className="btn-close" onClick={() => isStandalone ? navigate('/dashboard') : onCancel()}>
                        {readOnly ? '❌ Cerrar' : '❌ Cancelar'}
                    </button>
                    <button type="button" className="btn-print" onClick={handleDescargarPDF} style={{ backgroundColor: '#0288d1', color: '#fff', padding: '6px 15px', fontWeight: 'bold' }}>
                        🖨️ Imprimir Hoja
                    </button>
                    {!readOnly && (
                        <button type="button" className="btn-save" onClick={() => isStandalone ? handleGuardarDirecto() : onSave(formData)}>
                            💾 Guardar Anexo
                        </button>
                    )}
                </div>
            )}

            {firmaActiva && (
                <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', zIndex: 100000 }}>
                    <SignaturePad onSave={handleGuardarFirma} onCancel={() => setFirmaActiva(null)} />
                </div>
            )}
        </div>
    );

    if (isPdfMode) return contenidoFormulario;

    return (
        <div className={isStandalone ? "container" : "pe-modal-overlay"}>
            {contenidoFormulario}
        </div>
    );
};

export default PermisoEscalera;